var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    clipPath: "url(#clip0_18_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.6737 0H1.32632C0.593684 0 0 0.593684 0 1.32632V22.6737C0 23.4063 0.593684 24 1.32632 24H12.8211V14.7368H9.68421V11.0863H12.8042V8.42105C12.8042 5.31789 14.6947 3.62947 17.4611 3.62947C18.4 3.63368 19.3389 3.68421 20.2737 3.78947V7.02737H18.3621C16.8589 7.02737 16.5684 7.73895 16.5684 8.78737V11.1032H20.1684L19.7011 14.7368H16.5684V24H22.6737C23.4063 24 24 23.4063 24 22.6737V1.32632C24 0.593684 23.4063 0 22.6737 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.01cfbbd2565630dd19e7181be3b2373c.svg";
export { ForwardRef as ReactComponent };